import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PartnerRegistrationForm from "./pages/PartnerRegistrationForm";
import PartnerLogin from "./pages/PartnerLogin";
import PartnerDashboard from "./pages/PartnerDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Compliance from "./pages/Compliance";
import RefundPolicy from "./pages/RefundPolicy";
import { PageLoader } from "./components/ui";
import "./styles/globals.css";
// import PartnerLandingPage from "./pages/PartnerLandingPage";
import SalesCalculator from "./pages/SalesCalculator.js";

function App() {
  return (
    <HelmetProvider>
      <PageLoader />
      <BrowserRouter>
        <Routes>
          {/* <Route path="/" element={<PartnerLandingPage />} /> */}
          <Route path="/" element={<PartnerRegistrationForm />} />
          <Route path="/partner-register" element={<PartnerRegistrationForm />} />
          <Route path="/login" element={<PartnerLogin />} />
          <Route path="/dashboard" element={<PartnerDashboard />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/sales-calculator" element={<SalesCalculator />} />

        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
